export class ServiceRequest {
  startIndex?: number;
  limit?: number;
  orderBy?: string;

  constructor(init?: Partial<ServiceRequest>) {
    Object.assign(this, init);
  }

  // Getters & Setters
  getStartIndex(): number | undefined {
    return this.startIndex;
  }
  setStartIndex(value: number | undefined): void {
    this.startIndex = value;
  }

  getLimit(): number | undefined {
    return this.limit;
  }
  setLimit(value: number | undefined): void {
    this.limit = value;
  }

  getOrderBy(): string | undefined {
    return this.orderBy;
  }
  setOrderBy(value: string | undefined): void {
    this.orderBy = value;
  }
}
